document.querySelectorAll( '.b-color-card' ).forEach( ( block ) => {

    /////////////////////
    // BLOCK CODE HERE //
    /////////////////////

} );
    